import React, {useEffect, useContext} from 'react';
import './App';
import './App.scss';
import Tracking from './components/Tracking/Tracking';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Popup from './components/Popup/Popup';
import Main from './components/Main/Main';
import Cookie from './components/Cookie/Cookie';
import {StoreContext} from './helpers/StoreContext'
import {observer} from 'mobx-react-lite';
import { BrowserRouter as Router, Route } from "react-router-dom";

const App = () => {

  const rootStore = useContext(StoreContext);
  useEffect(() => {
    rootStore.styleStore.fetch();
  });

  const home = observer((props) => {
    if (props && props.match && props.match.params && props.match.params.key) {
        rootStore.guidanceCode = props.match.params.key;
        rootStore.hotelStore.ws.onopen = () => rootStore.hotelStore.fetch(rootStore.guidanceCode);
    }
    return (
        <div onClick={function () {rootStore.resetTimer()}} >
          <Tracking/>
          <Cookie />
          <Header />
          <Main/>
          <Footer/>
          <Popup/>
        </div>
    );
  });
  return (
    <Router>
      <Route path="/:key?" component={home} />
    </Router>
  );

};

export default App;
